@if (loading()) {
  <p class="cg-form-help">Loading comments…</p>
} @else {
  @if (comments().length === 0) {
    <app-admin-empty-state icon="message-circle" title="No comments yet" description="Start the discussion below." />
  } @else {
    <ul class="fr-comments">
      @for (comment of comments(); track comment._id) {
        <li class="fr-comments__item">
          <div class="fr-comments__head">
            <strong>{{ comment.createdByUser?.displayName ?? comment.createdBy }}</strong>
            <time>{{ comment.createdAt | date: 'medium' }}</time>
          </div>
          @if (editingId() === comment._id) {
            <app-admin-textarea
              name="editComment"
              [(value)]="editText"
              [rows]="3"
              [fullWidth]="true"
            />
            <div class="fr-comments__actions">
              <app-admin-button variant="primary" type="button" [disabled]="saving()" (click)="saveEdit(comment._id)">Save</app-admin-button>
              <app-admin-button variant="ghost" type="button" [disabled]="saving()" (click)="cancelEdit()">Cancel</app-admin-button>
            </div>
          } @else {
            <p class="fr-comments__text">{{ comment.comment }}</p>
            @if (canModify(comment)) {
              <div class="fr-comments__actions">
                <button type="button" class="fr-comments__link" (click)="startEdit(comment)">Edit</button>
                <button type="button" class="fr-comments__link fr-comments__link--danger" (click)="deleteComment(comment)">Delete</button>
              </div>
            }
          }
        </li>
      }
    </ul>
  }

  <div class="fr-comments__composer">
    <app-admin-textarea
      name="newComment"
      [(value)]="newComment"
      [rows]="4"
      [fullWidth]="true"
      placeholder="Write a comment…"
      [disabled]="saving()"
    />
    @if (error()) {
      <p class="fr-comments__error" role="alert">{{ error() }}</p>
    }
    <app-admin-button variant="primary" type="button" [disabled]="saving() || !newComment().trim()" (click)="postComment()">
      {{ saving() ? 'Posting…' : 'Post Comment' }}
    </app-admin-button>
  </div>
}
